import React, {useState, useEffect} from 'react';
import {get} from "../core/http";
import {API} from "../core/constants";
import PageHeader from "./ui/PageHeader";

const UserSubmissions = () => {
    const [submissions, setSubmissions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        get(`${API}/user-submissions`).then(result => {
            if (result.body) {
                setSubmissions(result.body)
            }
        }).finally(() => setLoading(false));
    }, []);

    return (
        <>
            <PageHeader title="User submissions" count={!loading ? submissions.length : null} />

            <div className="bg-base-100 rounded-lg border border-base-300 overflow-x-auto">
                {loading && !submissions.length ? (
                    <p className="text-center text-sm text-base-content/60 py-10">Loading...</p>
                ) : !submissions.length ? (
                    <p className="text-center text-sm text-base-content/60 py-10">No user submissions yet</p>
                ) : (
                    <table className="table table-sm">
                        <thead>
                        <tr>
                            <th>Title</th>
                            <th>Summary</th>
                        </tr>
                        </thead>
                        <tbody>
                        {submissions.map((submission, index) => (
                            <tr key={submission.id || index}>
                                <td className="font-medium align-top">{submission.title}</td>
                                <td className="text-sm text-base-content/70">{submission.summary}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    );
}

export default UserSubmissions;
